import React from 'react';
import {
	Grid, Col, Row,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import ReactGA from 'react-ga';
import {
	isEqual, map, cloneDeep, get, pick,
} from 'lodash';
import { bindActionCreators } from 'redux';
import { Image, Loader } from '@components/common';
import utils from '@utils';
import Actions, { thunks } from '@redux/payments';
import reportActions from '@redux/reports';
import { Table } from '@components';
import UrlProcessable from '@components/common/UrlProcessable';
import {
	PaymentHeader, DisputeFormModal, PaymentConfirmationModal, NonRKPayInvoicesTable,
} from './components';
import BalanceTransactionsTable from './components/table/balanceTransactionsTable';
import { paymentColumns, disputeColumns } from './utils/columnDefinition';
import CheckBox from './formatters/CheckBox';
import PhotoFormatter from './formatters/PhotoFormatter';
import PaymentsContext from './paymentsContext';
import PaymentFooter from './components/footer';

class Payments extends UrlProcessable {
	constructor(props) {
		super(props);
		const {
			params : { viewType },
			data,
			selectAll,
			totalCountForCheckbox,
			user,
			totalCount,
		} = props;
		this.state = {
			data                    : this.getFormatedData(data),
			loadingNonRKPayInvoices : false,
			totalCount,
		};
		this.columns = viewType !== 'disputes'
			? paymentColumns(viewType,
				selectAll,
				this.onCheckboxChange,
				this.selectAllChanged,
				this.actionClicked,
				this.payNowClicked,
				totalCountForCheckbox,
				CheckBox, PhotoFormatter, user.TimeZoneId) : disputeColumns;
	}

	componentDidMount = () => {
		this.componentDidMountAddOn();
	};

	UNSAFE_componentWillReceiveProps = (nextProps) => {
		const newState = cloneDeep(this.state);
		const lastProps = this.props;
		const {
			data,
			handleQueryStringOnBackButtonClick,
			params : { viewType },
			selectAll,
			location : { search },
			history : { action },
			resetPaymentsFilter,
			totalCountForCheckbox,
		} = nextProps;

		let callback;

		if (!isEqual(viewType, lastProps.params.viewType)) {
			resetPaymentsFilter();

			if (viewType !== 'disputes') {
				this.columns = paymentColumns(viewType,
					selectAll,
					this.onCheckboxChange,
					this.selectAllChanged,
					this.actionClicked,
					this.payNowClicked,
					totalCountForCheckbox,
					CheckBox,
					PhotoFormatter);
			} else this.columns = disputeColumns;
		}

		if (!isEqual(selectAll, lastProps.selectAll)) {
			this.columns = paymentColumns(viewType,
				selectAll,
				this.onCheckboxChange,
				this.selectAllChanged,
				this.actionClicked,
				this.payNowClicked,
				totalCountForCheckbox,
				CheckBox,
				PhotoFormatter);
		}

		if (!isEqual(data, lastProps.data)) {
			if (viewType === 'disputes') {
				this.columns = disputeColumns;
			} else {
				this.columns = paymentColumns(viewType,
					selectAll,
					this.onCheckboxChange,
					this.selectAllChanged,
					this.actionClicked,
					this.payNowClicked,
					totalCountForCheckbox,
					CheckBox,
					PhotoFormatter);
			}

			if (viewType === 'balance') {
				newState.data = data;
			} else {
				newState.data = this.getFormatedData(data);
			}
			this.setState(newState, callback);
		}

		if (search !== lastProps.location.search && viewType === lastProps.params.viewType && action === 'POP') handleQueryStringOnBackButtonClick(search);

		this.UNSAFE_componentWillReceivePropsAddOn(nextProps);
	}

	setOfficerOrAgency = (officerOrAgency) => {
		const { updateStoreProperties } = this.props;
		updateStoreProperties({ officerOrAgency });
	}

	setTotalCount = (totalCount) => {
		this.setState({ totalCount });
	}

	setLoadingNonRKPayInvoices = (loadingNonRKPayInvoices) => {
		this.setState({ loadingNonRKPayInvoices });
	}

	payNowClicked = (type, id = null) => () => {
		const { invoiceStatusChanged, params : { viewType } } = this.props;

		ReactGA.event({
			category : 'Payments',
			action   : 'Pay Now',
			label    : 'Single Invoice Payment',
		});

		invoiceStatusChanged({ type, viewType, id });
	}

	getFormatedData = (rawData) => (map(rawData, (item) => {
		const { activePage } = this.props;
		const TimeZoneId = get(this.props.user, ['TimeZoneId'], 'America/Chicago');
		const {
			StreetAddress,
			StreetAddress2,
			City,
			StateName,
			ZipCode,
			SentDateTimeUTC,
			JobStartDateTime,
			JobEndDateTime,
		} = item;

		let date = utils.parseUTCDateToTimeZone(JobStartDateTime, TimeZoneId).format('ddd, MMM D, YYYY');
		if (activePage === 'paid') date = utils.parseUTCDateToTimeZone(SentDateTimeUTC, TimeZoneId).format('ddd, MMM D, YYYY');

		return {
			rowId    : item.Id,
			jobId    : item.JobEventId,
			checked  : item.Checked,
			status   : item.Status,
			statusId : item.StatusId,

			location : {
				StreetAddress,
				StreetAddress2,
				City,
				StateName,
				ZipCode,
			},
			startdatetime : {
				date,
				startTime : utils.parseUTCDateToTimeZone(JobStartDateTime, TimeZoneId).format('h:mm A'),
				endTime   : utils.parseUTCDateToTimeZone(JobEndDateTime, TimeZoneId).format('h:mm A'),
			},
			officername : {
				name  : item.OfficerName,
				rank  : item.OfficerRank,
				photo : item.ContactPhotoUrl,
			},
			invoicedamount : {
				amount        : item.TotalInvoice,
				workedHours   : item.TotalJobHours,
				invoicedHours : item.TotalWorkedHours,
				date          : utils.parseUTCDateToTimeZone(item.InvoiceDate, TimeZoneId).format('ddd, MMM D, YYYY'),
				time          : utils.parseUTCDateToTimeZone(item.InvoiceDate, TimeZoneId).format('h:mm A'),
				dateFromNow   : utils.parseUTCDateToTimeZone(item.InvoiceDate, TimeZoneId).fromNow(),
			},
			SentDateTimeUTC   : utils.parseUTCDateToTimeZone(item.SentDateTimeUTC, TimeZoneId).format('ddd, MMM D, YYYY') || '',
			invoiceNo         : item.InvoiceNumber,
			disputeReason     : item.DisputeReason ? item.DisputeReason.ReasonName : '',
			showPaymentButton : this.props.user.IsStaffAdmin,
			isPrepaid         : item.InvoiceEstimatePrePayment,
		};
	}))

	applyFilter = (property) => (value) => this.props.applyCriteria([{ property, value }]);

	onSortColumn = (sortedColumn) => {
		const {
			updatePaymentsFilter,
			filters : {
				sortedColumn : currentSortedColumn,
				asc : currentAsc,
			},
		} = this.props;

		// Asc starts as true for a new column
		const asc = sortedColumn === currentSortedColumn ? !currentAsc : true;
		updatePaymentsFilter({ asc, sortedColumn });
	}

	onClickRow = ({ rowId }) => {
		const { params : { viewType }, push } = this.props;
		push({ pathname : `/payments/${rowId}`, search : queryString.stringify({ type : viewType }) });
	}

	onCheckboxChange = (index, newValue) => () => {
		const { updateCheckboxValue, params : { viewType } } = this.props;
		updateCheckboxValue(index, newValue, viewType);
	}

	selectAllChanged = (newValue) => () => {
		const { updateSelectAllValue, params : { viewType } } = this.props;
		updateSelectAllValue(viewType, newValue);
	}

	actionClicked = (type, id, isPrepaid = false) => () => {
		const {
			invoiceStatusChanged, updateModalState, updateStoreProperties, params : { viewType }, data,
		} = this.props;

		if (type === 'dispute') {
			updateModalState('disputeForm', true);
			updateStoreProperties({ activeDisputeId : id });
			return;
		}

		let isPrepaidAux = isPrepaid;

		if (viewType === 'review' && (type === 'selected' || type === 'bulk')) {
			const checks = type === 'selected' ? data.filter((item) => item.Checked) : data;

			const firstPrePayType = checks[0].InvoiceEstimatePrePayment;
			const anotherPrePayType = checks.some((item) => item.InvoiceEstimatePrePayment !== firstPrePayType);

			// Check if all selected invoices have the same prepay type
			if (anotherPrePayType) {
				utils.notify({
					type    : 'error',
					message : 'You cannot select Prepaid invoices with Non Prepaid invoices',
				});
				return;
			}

			// If all selected invoices are prepay, set isPrepaid flag to true
			if (firstPrePayType) {
				isPrepaidAux = true;
			}
		}

		ReactGA.event({
			category : 'Payments',
			action   : `Clicked ${viewType === 'review' ? 'Approve' : 'Pay'} ${type === 'selected' ? 'Selected' : 'All'} Invoices button`,
		});

		invoiceStatusChanged({
			type, id, viewType, isPrepaid : isPrepaidAux,
		});
	}

	handlePaymentConfirmationClick = (type) => {
		const { updateModalState, updateStoreProperties, push } = this.props;
		updateModalState('paymentConfirmation', false);
		if (type === 'cancel') {
			this.componentDidMountAddOn();
			// Reset active invoice Ids if user chooses not to pay approved invoices immediately
			updateStoreProperties({ activeInvoiceIds : [] });
		} else push({ pathname : '/payments/invoice' });
	}

	handleOnExportCSV = () => {
		const { exportCSV } = this.props;
		exportCSV();
	}

	openTourModal = () => {
		const { updateModalState } = this.props;
		updateModalState('tourModal', true);
	}

	onViewPaymentHistory = () => {
		const { updateReportFilter, filterForm } = this.props;
		updateReportFilter({ filterForm : { ...filterForm, reportType : 2 } }); // 2 is for payment history reports
	}

	render() {
		const {
			data,
			totalCount,
			loadingNonRKPayInvoices,
		} = this.state;

		const {
			loading,
			filters : {
				sortedColumn,
				asc,
				dateRange,
			},
			activeDisputeId,
			modals : { paymentConfirmation },
			user,
			activePage,
			push,
			successfulUpdateIds,
			activeInvoiceIds,
			officerOrAgency,
		} = this.props;

		const showPaidData = data.filter((item) => item.location).length === data.length && data.length > 0;

		const contextValue = {
			setOfficerOrAgency         : this.setOfficerOrAgency,
			applyFilter                : this.applyFilter,
			setTotalCount              : this.setTotalCount,
			setLoadingNonRKPayInvoices : this.setLoadingNonRKPayInvoices,
			filters                    : this.props.filters,
			officerOrAgency            : this.props.officerOrAgency,
			loading                    : loading.listData || loading.status || loadingNonRKPayInvoices,
			totalCount,
			activePage,
		};

		return (
			<PaymentsContext.Provider value={contextValue}>
				<PaymentHeader
					dateRange={dateRange}
					actionClicked={this.actionClicked}
					onExportCSV={this.handleOnExportCSV}
				/>
				<Grid className="legacy">
					<Row>
						<Col md={12} sm={12}>
							<Choose>
								<When condition={activePage === 'payment' && officerOrAgency === 'agency'}>
									<NonRKPayInvoicesTable />
								</When>
								<When condition={activePage === 'paid'}>
									<div className="table-responsive" id="paid-table">
										<table className="table">
											<thead>
												<tr>
													<th>Invoice Date</th>
													<th>Location</th>
													<th>Officers</th>
													<th className="text-right">Invoiced Amount</th>
												</tr>
											</thead>
											<tbody>
												<Choose>
													<When condition={showPaidData}>
														<For each="row" of={data}>
															<tr key={`paid-item_${row.rowId}`}>
																<td>
																	<Link to={`/payments/${row.rowId}`}>
																		{row.startdatetime.date}
																	</Link>
																</td>
																<td>
																	<Link to={`/payments/${row.rowId}`}>
																		{`${row.location.StreetAddress || ''} ${row.location.StreetAddress2 || ''}`}
																		<If condition={(row.location.StreetAddress || row.location.StreetAddress2)
																	&& (row.location.City || row.location.StateName || row.location.ZipCode)}
																		>
																			<br />
																		</If>
																		{row.location.City || ''}
																		{row.location.City && (row.location.StateName || row.location.ZipCode) ? ', ' : ' '}
																		{row.location.StateName || ''}
																		{row.location.StateName && row.location.ZipCode ? ' ' : ''}
																		{row.location.ZipCode || ''}
																	</Link>
																</td>
																<td>
																	<Link to={`/payments/${row.rowId}`}>
																		<div className="media">
																			<div className="media-left">
																				<Image
																					src={row.officername.photo}
																					fallbackSrc="avatar"
																					className="img-circle officer-img"
																				/>
																			</div>
																			<div className="media-body officer-info">
																				<div className="media-heading">{row.officername.name}</div>
																				{row.officername.rank}
																			</div>
																		</div>
																	</Link>
																</td>
																<td className="text-right">
																	<Link to={`/payments/${row.rowId}`}>
																		{utils.currencyFormatter(row.invoicedamount.amount)}
																		<br />
																		<small>{`(${row.invoicedamount.invoicedHours.toFixed(2)} hours)`}</small>
																	</Link>
																</td>
															</tr>
														</For>
													</When>
													<When condition={loading.listData}>
														<tr>
															<td colSpan="4" className="text-center paid-loader">
																<Loader active size="big" spinnerOnly />
															</td>
														</tr>
													</When>
												</Choose>
											</tbody>
										</table>
									</div>
								</When>
								<When condition={activePage !== 'balance'}>
									<Table
										columns={this.columns}
										data={data}
										sortedColumn={sortedColumn}
										asc={asc}
										loading={loading.listData || loading.status}
										updatingPaymentStatus={{
											loading  : loading.status,
											updated  : successfulUpdateIds.length,
											selected : activeInvoiceIds.length,
										}}
										onSortColumn={this.onSortColumn}
										onClickRow={this.onClickRow}
										className="client-portal-list-table"
									/>
								</When>
								<Otherwise>
									<BalanceTransactionsTable
										timeZone={user.TimeZoneId}
										rows={data}
										loading={loading.listData || loading.status}
										push={push}
									/>
								</Otherwise>
							</Choose>
						</Col>
					</Row>
				</Grid>
				<PaymentFooter
					onViewPaymentHistory={this.onViewPaymentHistory}
				/>
				<DisputeFormModal
					invoiceId={activeDisputeId}
					onConfirmedClose={this.componentDidMountAddOn}
				/>
				<PaymentConfirmationModal
					showModal={paymentConfirmation}
					title="Pay all approved invoices now?"
					handleOnClick={this.handlePaymentConfirmationClick}
					cancelBtnTxt="Pay later"
					confirmBtnTxt="Pay now"
				/>
			</PaymentsContext.Provider>
		);
	}
}

const mapStateToProps = (
	{
		router : {
			match : { params },
			location : { pathname },
		},
		payments : {
			data : {
				listData : data,
				totalCount,
			},
			loading,
			counts,
			filters,
			selectAll,
			modals,
			activeDisputeId,
			disputeConfirmation,
			totalCountForCheckbox,
			activeInvoiceIds,
			successfulUpdateIds,
			officerOrAgency,
		},
		reports : { filterForm },
		app : { user },
	},
) => ({
	params,
	data,
	loading,
	counts,
	filters,
	officerOrAgency,
	totalCount,
	selectAll,
	modals,
	activeDisputeId,
	disputeConfirmation,
	totalCountForCheckbox,
	activeInvoiceIds,
	successfulUpdateIds,
	filterForm,
	user,
	activePage : pathname.split('/')[3],
});

const mapDispatchToProps = (dispatch) => ({
	...pick(bindActionCreators(Actions, dispatch), ['updateStoreProperties', 'updateModalState', 'resetPaymentsFilter']),
	...pick(bindActionCreators(thunks, dispatch), [
		'applyCriteria',
		'processUrl',
		'invoiceStatusChanged',
		'handleQueryStringOnBackButtonClick',
		'updateCheckboxValue',
		'updateSelectAllValue',
		'updatePaymentsFilter',
		'exportCSV',
	]),
	push               : bindActionCreators(pushAction, dispatch),
	updateReportFilter : bindActionCreators(reportActions, dispatch).updateStoreProperties,
});

export default connect(mapStateToProps, mapDispatchToProps)(Payments);
